module.exports = __webpack_public_path__ + "static/media/wizualizacja-121.912d2a17.png";